"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartContext = exports.useCartActions = void 0;
const react_1 = require("react");
const reducers_1 = require("../reducers");
const _1 = require(".");
const CartContext = (0, react_1.createContext)({ state: reducers_1.initialState });
exports.CartContext = CartContext;
const useCartActions = (dispatchFromProvider) => {
    const context = (0, react_1.useContext)(CartContext);
    if (!context)
        console.warn('useCartActions should be used with CartProvider');
    const { state, dispatch } = context;
    if (!dispatchFromProvider && !dispatch)
        throw new Error('No dispatch function has been set');
    const actions = { getState: () => state };
    const actionKeys = Object.keys(_1.actionCreators);
    return actionKeys.reduce((previousValue, currentValue) => (Object.assign(Object.assign({}, previousValue), { [`${currentValue}Connected`]: _1.actionCreators[currentValue](state, dispatchFromProvider !== null && dispatchFromProvider !== void 0 ? dispatchFromProvider : dispatch) })), actions);
};
exports.useCartActions = useCartActions;
